/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_EventsInputs */

const en_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps & Clinics`)
};

const es_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campamentos y clínicas`)
};

const de_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps & Kurse`)
};

const zh_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`训练营与训练班`)
};

const ar_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المعسكرات والورش التدريبية`)
};

const fr_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps et stages`)
};

const vi_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trại và lớp chuyên đề`)
};

const sw_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kambi na mafunzo`)
};

const th_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แคมป์และคลินิกกอล์ฟ`)
};

const bs_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampovi i kursevi`)
};

const ja_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンプ&クリニック`)
};

const ko_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캠프 & 클리닉`)
};

const pt_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acampamentos e clínicas`)
};

const it_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camp e clinic`)
};

const sv_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läger och kurser`)
};

const nl_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampen & clinics`)
};

const da_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps og kurser`)
};

const nb_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leirer og kurs`)
};

const fi_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leirit ja kurssit`)
};

const pl_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obozy i szkolenia`)
};

const ru_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лагеря и мастер-классы`)
};

const tr_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamplar ve eğitim programları`)
};

const hi_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैंप और प्रशिक्षण सत्र`)
};

const id_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamp & kelas`)
};

const ms_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kem & kelas`)
};

const cs_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kempy a kurzy`)
};

const el_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κατασκηνώσεις & σεμινάρια`)
};

const he_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחנות וסדנאות`)
};

const af_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampe en kursusse`)
};

const hu_footer_link_events = /** @type {(inputs: Footer_Link_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Táborok és tanfolyamok`)
};

/**
* | output |
* | --- |
* | "Camps & Clinics" |
*
* @param {Footer_Link_EventsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_link_events = /** @type {((inputs?: Footer_Link_EventsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_EventsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_events(inputs)
	if (locale === "de") return de_footer_link_events(inputs)
	if (locale === "zh") return zh_footer_link_events(inputs)
	if (locale === "ar") return ar_footer_link_events(inputs)
	if (locale === "fr") return fr_footer_link_events(inputs)
	if (locale === "vi") return vi_footer_link_events(inputs)
	if (locale === "sw") return sw_footer_link_events(inputs)
	if (locale === "th") return th_footer_link_events(inputs)
	if (locale === "bs") return bs_footer_link_events(inputs)
	if (locale === "ja") return ja_footer_link_events(inputs)
	if (locale === "ko") return ko_footer_link_events(inputs)
	if (locale === "pt") return pt_footer_link_events(inputs)
	if (locale === "it") return it_footer_link_events(inputs)
	if (locale === "sv") return sv_footer_link_events(inputs)
	if (locale === "nl") return nl_footer_link_events(inputs)
	if (locale === "da") return da_footer_link_events(inputs)
	if (locale === "nb") return nb_footer_link_events(inputs)
	if (locale === "fi") return fi_footer_link_events(inputs)
	if (locale === "pl") return pl_footer_link_events(inputs)
	if (locale === "ru") return ru_footer_link_events(inputs)
	if (locale === "tr") return tr_footer_link_events(inputs)
	if (locale === "hi") return hi_footer_link_events(inputs)
	if (locale === "id") return id_footer_link_events(inputs)
	if (locale === "ms") return ms_footer_link_events(inputs)
	if (locale === "cs") return cs_footer_link_events(inputs)
	if (locale === "el") return el_footer_link_events(inputs)
	if (locale === "he") return he_footer_link_events(inputs)
	if (locale === "af") return af_footer_link_events(inputs)
	if (locale === "hu") return hu_footer_link_events(inputs)
	return en_footer_link_events(inputs)
});